/**
 * Extracts an error message from an API error response
 * @param error - The error object from RTK Query or similar
 * @param fallback - Optional fallback message if no error message is found
 * @returns The extracted error message or fallback
 */
export const extractErrorMessage = (
  error: any,
  fallback = 'An unexpected error occurred'
): string => {
  // The backend adds `error_message` to every 4xx; DRF-native errors carry only
  // `detail` + `error_message`, without `details`.
  return (
    error?.data?.details ||
    error?.data?.message ||
    error?.data?.error_message ||
    error?.message ||
    fallback
  );
};

/**
 * Extracts error messages from multiple error objects, returning the first non-empty message
 * @param errors - Array of error objects
 * @param fallback - Optional fallback message if no error messages are found
 * @returns The first extracted error message or fallback
 */
export const extractErrorMessages = (
  errors: any[],
  fallback = 'An unexpected error occurred'
): string => {
  for (const error of errors) {
    if (!error) continue;
    const message = extractErrorMessage(error, '');
    if (message) return message;
  }
  return fallback;
};
